<template>
    <div>
        <div class="container text-center mb-5">
            <!-- <div class="col-md-12">
                <boton-atras :nombre_ruta="'Cuentas-Publicas'"/>
            </div> -->
          <!-- <h1 class="bold300 text-uppercase" style=" font-weight:500;">{{data[0].titulo}}</h1> -->
            <h3 class="mt-4">{{ titulo_principal }}</h3>
        </div>
        <!-- <pre>{{data}}</pre> -->
        <tabla-simple id="tablaCPRB" class="mt-5" :titulo="data.text" :datos="data" />
        <span v-html="fecha_actualizacion"></span>
    </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import CuentasPublicas from "@/services/rendicionDeCuentas/cuentasPublicas/cuentasPublicas.js"
const _serviciosCuentasPublicas = new CuentasPublicas();
import tablaSimple from '@/components/tablaSimple.vue';
import botonAtras from '../../button-atras.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";
export default {
    components: { tablaSimple, botonAtras},
    mixins: [DateFormat],
    created(){
        this.getEstadosPrepyProgOP();
    },
    data(){
        return{
            titulo_principal: '',
            data:[],
            fecha_actualizacion:'',
        }
    },
    methods:{
        async getEstadosPrepyProgOP(){
            try {
                let ruta = mapFun.cuentasEstadosPrepProgOP;
                let ruta_completa = ruta+'TVI-2014.json';
                const response = await _serviciosCuentasPublicas.getEPyPOP(ruta_completa);
                this.data = response.data;
                this.titulo_principal = response.data[0].titulo;
                let fecha_texto = response.data[0].fecha_actualizacion;
                this.fecha_actualizacion = this.DateFormatText(fecha_texto);
                this.data = this.data.map(function (mapeoSelect) {
                    return {
                        id: mapeoSelect.id,
                        text: mapeoSelect.descripcion,
                        seccion: mapeoSelect.contenido,
                    };
                });
                this.data = this.data[0];
            } catch (error) {
                console.log('error', error.message);
            }
        },
    }
}
</script>